import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ExternalLink, ArrowLeft } from "lucide-react";
import PageLayout from "@/components/PageLayout";
import { merchItems } from "@/data/mockData";

const MerchDetail = () => {
  const { id } = useParams();
  const item = merchItems.find((m) => m.id === id);

  if (!item) {
    return (
      <PageLayout>
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-foreground">Product not found</h1>
          <Link to="/merch" className="text-muted-foreground hover:text-foreground mt-4 inline-block">← Back to Merch</Link>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <div className="max-w-7xl mx-auto">
        <Link to="/merch" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8">
          <ArrowLeft className="w-4 h-4" /> Back to Merch
        </Link>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="lg:sticky lg:top-24 lg:self-start space-y-8 order-2 lg:order-1">
            <div>
              <span className="inline-block bg-accent text-muted-foreground text-xs font-semibold px-3 py-1 rounded-full mb-3">
                {item.category}
              </span>
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-2">{item.title}</h1>
              <p className="text-xl font-bold text-foreground">{item.price}</p>
            </div>
            <p className="text-muted-foreground leading-relaxed text-sm">{item.info}</p>
            <div>
              <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-widest mb-4">Buy</h3>
              <div className="space-y-3">
                {item.purchaseLinks.map((l) => (
                  <a key={l.name} href={l.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between glass-card-hover p-4 group">
                    <span className="text-foreground font-medium">{l.name}</span>
                    <div className="flex items-center gap-3">
                      <span className="text-muted-foreground text-sm font-semibold">{l.price}</span>
                      <ExternalLink className="w-5 h-5 text-muted-foreground group-hover:text-foreground transition-colors" />
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }} className="order-1 lg:order-2">
            <div className="aspect-square rounded-lg overflow-hidden">
              <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
            </div>
          </motion.div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MerchDetail;
